export default [
  {
    path: "/pages/profile",
    name: "page-profile",
    component: () => import("@/views/pages/Profile.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Pages" },
        { title: "Profile", active: true }
      ],
      pageTitle: "Profile",
      rule: "editor"
    }
  },
  {
    path: "/pages/user-settings",
    name: "page-user-settings",
    component: () => import("@/views/pages/user-settings/UserSettings.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Pages" },
        { title: "User Settings", active: true }
      ],
      pageTitle: "Settings",
      rule: "editor"
    }
  },
  {
    path: "/pages/faq",
    name: "page-faq",
    component: () => import("@/views/pages/Faq.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Pages" },
        { title: "FAQ", active: true }
      ],
      pageTitle: "FAQ",
      rule: "editor"
    }
  },
  {
    path: "/pages/knowledge-base",
    name: "page-knowledge-base",
    component: () => import("@/views/pages/KnowledgeBase.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Pages" },
        { title: "KnowledgeBase", active: true }
      ],
      pageTitle: "KnowledgeBase",
      rule: "editor"
    }
  },
  {
    path: "/pages/knowledge-base/category",
    name: "page-knowledge-base-category",
    component: () => import("@/views/pages/KnowledgeBaseCategory.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Pages" },
        { title: "KnowledgeBase", url: "/pages/knowledge-base" },
        { title: "Category", active: true }
      ],
      parent: "page-knowledge-base",
      rule: "editor"
    }
  },
  {
    path: "/pages/knowledge-base/category/question",
    name: "page-knowledge-base-category-question",
    component: () => import("@/views/pages/KnowledgeBaseCategoryQuestion.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Pages" },
        { title: "KnowledgeBase", url: "/pages/knowledge-base" },
        { title: "Category", url: "/pages/knowledge-base/category" },
        { title: "Question", active: true }
      ],
      parent: "page-knowledge-base",
      rule: "editor"
    }
  },
  {
    path: "/pages/search",
    name: "page-search",
    component: () => import("@/views/pages/Search.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Pages" },
        { title: "Search", active: true }
      ],
      pageTitle: "Search",
      rule: "editor"
    }
  },
  {
    path: "/pages/invoice",
    name: "page-invoice",
    component: () => import("@/views/pages/Invoice.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Pages" },
        { title: "Invoice", active: true }
      ],
      pageTitle: "Invoice",
      rule: "editor"
    }
  }
];

